import { createApp } from 'vue'
// import ElementPlus from 'element-plus'
// import 'element-plus/dist/index.css'
// import './style.css'
import App from './App.vue'
import router from './router'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import store from './store'
// import './api/mock.js'
import './assets/less/index.less'
import api from './api/api'
import i18n from './language/index'
import { get } from './utils/Cache.js'
const app = createApp(App)

app.use(i18n); // 使用i18n插件

// app.use(ElementPlus)
// 封装api
app.config.globalProperties.$api = api
// 调用addMenu方法，从缓存获取menu
store.commit("addMenu", router)
// 输入不匹配的路径
function checkRouter(path) {
  // router.getRoutes() 方法来获取路由器中定义的所有路由
  // 根据条件 route.path == path 过滤路由
  // .length 检查过滤后的路由的数量
  let hasCheck = router.getRoutes().filter(route => route.path == path).length
  if (hasCheck) {
    return true
  } else {
    return false
  }
}
checkRouter()
// 全局路由守卫
// 如果用户未登录并且要跳转的页面不是登录页面，则跳转到登录页面。
// 如果用户已登录，并且要跳转的页面通过权限检查，则继续路由切换。
// // 如果用户已登录，并且要跳转的页面未通过权限检查，则跳转到空路由或其他指定的路由。
// to：要导航到的目标路由对象  from：当前导航的来源路由对象，上一个路由。  next：控制导航流程
router.beforeEach((to,from,next) => {
  console.log('to', to)
  // 获取token
  const token = JSON.parse(get('token'))
  const menu = JSON.parse(get('menu'))
  console.log('menu',menu);
  // 如果没有token，并且 to.name 不是登录页面，则跳转到登录页面
  if (!token && to.name !== 'login') {
    // 跳转
      next({name:'login'})
    // 如果要导航到的路由在路由器中不存在（通过调用 checkRouter 函数进行检查），则跳转到默认的 '/' 页面。
  } else if (!checkRouter(to.path)) {
    console.log(!checkRouter(to.path));
    // 如果没有menu，权限有问题，则跳转到登录页面
    if (menu.length > 0) {
      next({ name:'device-list'})
    }else{
      localStorage.clear();
      next({name:'login'})
    }
    // store.commit("addMenu", router);
} else if(token && to.name == 'login'){
  console.log("有token");
  next({name:'device-list'})
} else {
  // 允许导航
    next()
}
}) 

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.use(router).use(store).use(i18n)
app.mount('#app')
